import Evaluator, { EvaluatorContext, EvaluatorRequest } from "../../Evaluator"
import ExperimentEvaluation from "../../experiment/ExperimentEvaluation"
import ExperimentContextualEvaluator from "../../experiment/ExperimentContextualEvaluator"

export class InAppMessageExperimentEvaluator extends ExperimentContextualEvaluator {
  constructor(evaluator: Evaluator) {
    super(evaluator)
  }

  /**
   * @override
   */
  resolve(
    request: EvaluatorRequest,
    context: EvaluatorContext,
    evaluation: ExperimentEvaluation
  ): ExperimentEvaluation {
    context.setProperty("experiment_id", evaluation.experiment.id)
    context.setProperty("experiment_key", evaluation.experiment.key)
    context.setProperty("variation_id", evaluation.variationId)
    context.setProperty("variation_key", evaluation.variationKey)
    context.setProperty("experiment_decision_reason", evaluation.reason)

    return evaluation
  }
}
